import { type Position } from "./types"
import { Grid } from "./grid"

export function posKey(pos: Position): string {
  return `${pos.row},${pos.col}`
}

/** BFS flood fill through LAND-connected tiles. Returns array of islands (each an array of positions). */
export function findIslands(grid: Grid): Position[][] {
  const visited = new Set<string>()
  const islands: Position[][] = []

  grid.forEachTile((pos) => {
    const key = posKey(pos)
    if (visited.has(key)) return

    // BFS from this tile
    const island: Position[] = []
    const queue: Position[] = [pos]
    visited.add(key)

    while (queue.length > 0) {
      const current = queue.shift()!
      island.push(current)

      for (const neighbor of grid.getLandConnectedNeighbors(current)) {
        const nKey = posKey(neighbor)
        if (!visited.has(nKey)) {
          visited.add(nKey)
          queue.push(neighbor)
        }
      }
    }

    islands.push(island)
  })

  return islands
}

/** Find the island containing a specific position */
export function findIslandContaining(grid: Grid, target: Position): Position[] | null {
  const tile = grid.get(target)
  if (!tile) return null

  const visited = new Set<string>()
  const island: Position[] = []
  const queue: Position[] = [target]
  visited.add(posKey(target))

  while (queue.length > 0) {
    const current = queue.shift()!
    island.push(current)

    for (const neighbor of grid.getLandConnectedNeighbors(current)) {
      const nKey = posKey(neighbor)
      if (!visited.has(nKey)) {
        visited.add(nKey)
        queue.push(neighbor)
      }
    }
  }

  return island
}
